/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import withFlavors from '../_commons/WithFlavors';
import flavors from './flavors';
import defaultProps from './defaultProps';
import { getUuid } from '@front10/helpers/dist/uuid';

import ErrorBoundary from '../../utils/ErrorBoundary';

import Box from '../../elements/Box';
import Text from '../../elements/Text';
import FareItemDepartureInfo from '../_commons/atoms/FareItemDepartureInfo';
import FareItemSoldBy from '../_commons/atoms/FareItemSoldBy';
import FareItemReturnInfo from '../_commons/atoms/FareItemReturnInfo';
import FareItemOriginDestination from '../_commons/atoms/FareItemOriginDestination';
import FareItemJourneyType from '../_commons/atoms/FareItemJourneyType';
import FareItemTravelClass from '../_commons/atoms/FareItemTravelClass';
import FareItemPrice from '../_commons/atoms/FareItemPrice';
import FareItemLastSeen from '../_commons/atoms/FareItemLastSeen';
import FareItemRoute from '../_commons/atoms/FareItemRoute';
import FareItemTripDuration from '../_commons/atoms/FareItemTripDuration';
import FareItemCallToAction from '../_commons/atoms/FareItemCallToAction';
import Separator from '../_commons/atoms/Separator';
import FareItemMiles from '../_commons/atoms/FareItemMiles';
import ImageHeader from '../../elements/ImageHeader';
import FareItemDate from '../_commons/atoms/FareItemDate';
import FareItemNoPriceAvailable from '../_commons/atoms/FareItemNoPriceAvailable';
import FareItemCheckRestriction from '../_commons/atoms/FareItemCheckRestriction';
import FareItemAirline from '../_commons/atoms/FareItemAirline';
import FareItemRating from '../_commons/atoms/FareItemRating';
import FareItemTags from '../_commons/atoms/FareItemTags';
import FareItemHotelName from '../_commons/atoms/FareItemHotelName';

import { handleFareItemInteraction } from '../_commons/commonFns';

const FareItemCard = (props) => {
  const {
    showImageFullHeight,
    usedErrorBoundary,
    showRoute,
    showDate,
    showDepartureInfo,
    showReturnInfo,
    showJourneyType,
    showTravelClass,
    showLastSeen,
    showPrice,
    showDurationTrip,
    showPill,
    showOriginDestination,
    showMiles,
    showDepartureReturnBeforePrice,
    showHorizontalSeparator,
    showBackgroundImage,
    showCallToAction,
    fareItemCallToActionContainer,
    separatorDatesProps,
    separatorJourneyTypeProps,
    fareItemDate,
    fareItemDepartureInfo,
    fareItemReturnInfo,
    fareItemJourneyType,
    fareItemTravelClass,
    fareItemOriginDestination,
    fareItemPrice,
    fareItemTripDuration,
    fareBodyItem,
    fareFooterItem,
    fareItemLastSeen,
    fareItemDepartureReturn,
    fareItemJourneyTypeTravelClass,
    fareItemPill,
    fareItemRoute,
    fareItemMiles,
    fareItemBackgroundImage,
    fareItemHorizontalSeparator,
    fareItemNoPriceAvailable,
    fareItemCallToAction,
    fareItemCheckRestriction,
    fareItemAirline,
    tabIndex,
    data,
    navigationInfo,
    focusReferences,
    tabIndexCallToAction,
    fareItemCard,
    onFocus,
    experimentalRenderAtoms,
    experimentalRenderAtomsFooter = showCallToAction ? true : false,
    availableAtomsFooter = props.experimentalRenderAtomsFooter === undefined && showCallToAction
      ? ['FareItemCallToAction']
      : [],
    fareItemSoldBy,
    fareItemRating,
    fareItemTags,
    fareItemHotelName,
    ariaHidden,
    ariaLabel = '',
    showCheckRestriction = false
  } = props;

  let availableAtoms = props.availableAtoms;

  const availableAtomsIndex =
    availableAtoms.length !== 0
      ? availableAtoms.findIndex((x) => x === 'FareItemCallToAction')
      : -1;
  const availableAtomsFooterIndex =
    availableAtomsFooter.length !== 0
      ? availableAtomsFooter.findIndex((x) => x === 'FareItemCallToAction')
      : -1;
  if (availableAtomsIndex !== -1 && availableAtomsFooterIndex !== -1) {
    availableAtoms.splice(availableAtomsIndex, 1);
  }
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const id = getUuid();

  const {
    handleCallToAction,
    handleClick,
    handleItemKeyDown,
    handleCallToActionKeyDown,
    hasInteraction
  } = handleFareItemInteraction(props);

  const cursorClass = hasInteraction ? 'fr-cursor-pointer' : '';

  const departureReturnAtom = data && (showDepartureInfo || showReturnInfo) && (
    <Box {...fareItemDepartureReturn}>
      {showDepartureInfo && fareItemDepartureInfo && (
        <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
      )}
      {showDepartureInfo &&
        showReturnInfo &&
        data.formattedDepartureDate &&
        data.formattedReturnDate && <Separator {...separatorDatesProps} floatLeft />}
      {showReturnInfo && fareItemReturnInfo && (
        <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
      )}
    </Box>
  );
  const pillStyles =
    showBackgroundImage && !showImageFullHeight
      ? { position: 'absolute', width: '100%', zIndex: '1' }
      : null;

  /**
   * This code is experimental, test mode is added to see how the user can reorder the atoms
   */

  let elements = {};
  if (experimentalRenderAtoms) {
    // 'FareItemOriginDestination',
    // 'FareItemRoute',
    // 'FareItemTripDuration',
    // 'FareItemSeparator',
    // 'FareItemMiles',
    // 'FareItemPrice',
    // 'FareItemLastSeen',
    // 'FareItemDepartureReturnInfo',
    // 'FareItemJourneyTypeTravelClass',
    // 'FareItemCallToAction',
    // 'FareItemCheckRestriction',
    // 'FareItemAirline',
    // 'FareItemSoldBy',
    // 'FareItemRating',
    // 'FareItemTags',
    // 'FareItemHotelName'

    elements = {
      FareItemOriginDestination: showOriginDestination && fareItemOriginDestination && (
        <FareItemOriginDestination key="od" {...fareItemOriginDestination} {...data} />
      ),
      FareItemRoute: showRoute && <FareItemRoute key="route" {...fareItemRoute} {...data} />,
      FareItemTripDuration: showDurationTrip && fareItemTripDuration && (
        <FareItemTripDuration key="dur" {...fareItemTripDuration} {...data} />
      ),
      FareItemSeparator: showHorizontalSeparator && fareItemHorizontalSeparator && (
        <Separator key="sep" content="" {...fareItemHorizontalSeparator} />
      ),
      FareItemMiles: showMiles && fareItemMiles && (
        <FareItemMiles key="mil" {...fareItemMiles} {...data} />
      ),
      FareItemPrice: showPrice && fareItemPrice && (
        <FareItemPrice key="pri" {...fareItemPrice} {...data} />
      ),
      FareItemLastSeen: showLastSeen && fareItemLastSeen && (
        <FareItemLastSeen key="lsee" {...fareItemLastSeen} {...data} />
      ),
      FareItemDepartureReturnInfo: (showDepartureInfo || showReturnInfo) && (
        <Box {...fareItemDepartureReturn} key="dri">
          {showDepartureInfo && fareItemDepartureInfo && (
            <FareItemDepartureInfo {...fareItemDepartureInfo} {...data} />
          )}
          {showDepartureInfo &&
            showReturnInfo &&
            data.formattedDepartureDate &&
            data.formattedReturnDate && <Separator {...separatorDatesProps} floatLeft />}
          {showReturnInfo && fareItemReturnInfo && (
            <FareItemReturnInfo {...fareItemReturnInfo} {...data} />
          )}
        </Box>
      ),
      FareItemJourneyTypeTravelClass: (showJourneyType || showTravelClass) && (
        <Box {...fareItemJourneyTypeTravelClass} key="jt">
          {showJourneyType && <FareItemJourneyType {...fareItemJourneyType} {...data} />}
          {showTravelClass && fareItemTravelClass && (
            <Separator {...separatorJourneyTypeProps} floatLeft />
          )}
          {showTravelClass && <FareItemTravelClass {...fareItemTravelClass} {...data} />}
        </Box>
      ),
      FareItemCallToAction: showCallToAction && fareItemCallToAction && (
        <Box key="cta" {...fareItemCallToActionContainer}>
          <FareItemCallToAction
            {...fareItemCallToAction}
            {...data}
            focusReferences={focusReferences}
            tabIndex={tabIndexCallToAction}
            onClick={handleCallToAction}
            onKeyDown={handleCallToActionKeyDown}
            ariaLabelledBy={`fareItemCard-${id}`}
          />
        </Box>
      ),
      FareItemCheckRestriction: (
        <FareItemCheckRestriction key="rest" {...fareItemCheckRestriction} {...data} />
      ),
      FareItemAirline: <FareItemAirline key="air" {...data} {...fareItemAirline} />,
      FareItemSoldBy: <FareItemSoldBy key="sold" {...data} {...fareItemSoldBy} />,
      FareItemRating: <FareItemRating key="rating" {...data} {...fareItemRating} />,
      FareItemTags: <FareItemTags key="tags" {...data} {...fareItemTags} />,
      FareItemHotelName: <FareItemHotelName key="hotelName" {...data} {...fareItemHotelName} />
    };
  }

  /**
   * End experimental
   */
  const layoutToRender = (
    <Box
      id={`fareItemCard-${id}`}
      position="relative"
      onClick={handleClick}
      onFocus={onFocus}
      onKeyDown={handleItemKeyDown}
      dataTestId="fareItemCard"
      tabIndex={tabIndex ? 0 : null}
      focusable={tabIndex}
      focusReferences={!showCallToAction ? focusReferences : null}
      role={!showCallToAction ? 'button' : null}
      {...fareItemCard}
      className={`fr-fareitem-card ${cursorClass} ${className} `}
      style={style}
      ariaHidden={ariaHidden ?? null}
      onMouseEnter={() => {
        if (props.onMouseEnter) {
          props.onMouseEnter();
        }
      }}
      onMouseLeave={() => {
        if (props.onMouseLeave) {
          props.onMouseLeave();
        }
      }}
    >
      {ariaLabel && <Text className="fr-sr-only">{ariaLabel}</Text>}
      {showPill && fareItemPill && (
        <Box display="flex" justifyContent="end" style={pillStyles}>
          <Text {...fareItemPill}>{data ? data.navigationInfo : navigationInfo}</Text>
        </Box>
      )}
      {showBackgroundImage && !showImageFullHeight && (
        <ImageHeader
          image={data && data.destinationImage && data.destinationImage}
          {...fareItemBackgroundImage}
        />
      )}
      <Box
        display="flex"
        flexDirection="column"
        {...fareBodyItem}
        className="fr-fareitem-card-body"
      >
        {showDate && fareItemDate && (
          <FareItemDate {...fareItemDate} date={data && data.departureDate && data.departureDate} />
        )}
        {data && data.dataType !== 'EMPTY_FROM_API' ? (
          <>
            {experimentalRenderAtoms && availableAtoms.map((e) => elements[e])}
            {!experimentalRenderAtoms && (
              <>
                {showOriginDestination && fareItemOriginDestination && (
                  <FareItemOriginDestination {...fareItemOriginDestination} {...data} />
                )}
                {showDurationTrip && fareItemTripDuration && (
                  <FareItemTripDuration {...fareItemTripDuration} {...data} />
                )}
                {/* a boolean prop to change the atom's order */}
                {showDepartureReturnBeforePrice && departureReturnAtom}
                {showHorizontalSeparator && fareItemHorizontalSeparator && (
                  <Separator content="" {...fareItemHorizontalSeparator} />
                )}
                {showMiles && fareItemMiles && <FareItemMiles {...fareItemMiles} {...data} />}
                {showPrice && fareItemPrice && <FareItemPrice {...fareItemPrice} {...data} />}
                {showLastSeen && fareItemLastSeen && (
                  <FareItemLastSeen {...fareItemLastSeen} {...data} />
                )}
                {/* a boolean prop to change the atom's order */}
                {!showDepartureReturnBeforePrice && departureReturnAtom}
                {(showJourneyType || showTravelClass) && (
                  <Box {...fareItemJourneyTypeTravelClass}>
                    {showJourneyType && <FareItemJourneyType {...fareItemJourneyType} {...data} />}
                    {showTravelClass && fareItemTravelClass && (
                      <Separator {...separatorJourneyTypeProps} floatLeft />
                    )}
                    {showTravelClass && <FareItemTravelClass {...fareItemTravelClass} {...data} />}
                  </Box>
                )}
                {/* FareItemCallToAction */}
                {showCallToAction && fareItemCallToAction && (
                  <Box {...fareItemCallToActionContainer}>
                    <FareItemCallToAction
                      {...fareItemCallToAction}
                      {...data}
                      tabIndex={tabIndexCallToAction}
                      onClick={handleCallToAction}
                      onKeyDown={handleCallToActionKeyDown}
                    />
                  </Box>
                )}
              </>
            )}
          </>
        ) : (
          <>
            <FareItemNoPriceAvailable
              message="cmp-fare-item-card-no-fare-available"
              {...fareItemNoPriceAvailable}
              tabIndex={tabIndexCallToAction}
              onClick={handleCallToAction}
              onKeyDown={handleCallToActionKeyDown}
            />
            {showCheckRestriction && (
              <FareItemCheckRestriction key="rest" {...fareItemCheckRestriction} {...data} />
            )}
          </>
        )}
      </Box>

      {experimentalRenderAtoms && experimentalRenderAtomsFooter && (
        <Box
          display="flex"
          flexDirection="column"
          //TODO: Leave the next line looking for better compatibility so as not to break any components
          {...fareBodyItem}
          {...fareFooterItem}
          className="fr-fareitem-card-footer"
        >
          {availableAtomsFooter.map((e) => elements[e])}
        </Box>
      )}
    </Box>
  );

  const renderComponent =
    showBackgroundImage && showImageFullHeight ? (
      <ImageHeader
        image={data && data.destinationImage && data.destinationImage}
        {...fareItemBackgroundImage}
      >
        {layoutToRender}
      </ImageHeader>
    ) : (
      layoutToRender
    );

  return usedErrorBoundary ? <ErrorBoundary>{renderComponent}</ErrorBoundary> : renderComponent;
};

FareItemCard.propTypes = {
  showImageFullHeight: PropTypes.bool,
  ariaHidden: PropTypes.bool,
  /**
   * OnClick event
   */
  onClick: PropTypes.func,
  /**
   * OnClick event
   */
  onFocus: PropTypes.func,
  /**
   * Call to action onClick event
   */
  callToActionOnClick: PropTypes.func,
  /**
   * OnKeyDown event
   */
  onKeyDown: PropTypes.func,
  /**
   * Props of fareItemDate
   */
  fareItemDate: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDepartureInfo
   */
  fareItemDepartureInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemTripDuration
   */
  fareItemTripDuration: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemReturnInfo
   */
  fareItemReturnInfo: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemDeparture and fareItemReturn together
   */
  fareItemDepartureReturn: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemJourneyType and fareItemTravelClass together
   */
  fareItemJourneyTypeTravelClass: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemJourneyType
   */
  fareItemJourneyType: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemTravelClass
   */
  fareItemTravelClass: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemOriginDestination
   */
  fareItemOriginDestination: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemPrice
   */
  fareItemPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of tileBodyItem
   */
  fareBodyItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of footer wrapper div
   */
  fareFooterItem: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemCard
   */
  fareItemCard: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemLastSeen
   */
  fareItemLastSeen: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemPill
   */
  fareItemPill: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemMiles
   */
  fareItemMiles: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemBackgroundImage
   */
  fareItemBackgroundImage: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemHorizontalSeparator
   */
  fareItemHorizontalSeparator: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemNoPriceAvailable
   */
  fareItemNoPriceAvailable: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemCallToAction
   */
  fareItemCallToAction: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of fareItemCallToActionContainer
   */
  fareItemCallToActionContainer: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on tabIndex in FareItem
   */
  tabIndex: PropTypes.bool,
  /**
   * Define if the CallToAction will have focus for Screen Readers
   */
  tabIndexCallToAction: PropTypes.bool,
  /**
   * Function to handle focus renference of the component
   */
  focusReferences: PropTypes.func,
  /**
   * Props of separator
   */
  separatorDatesProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of separator
   */
  separatorJourneyTypeProps: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the Date section
   */
  showDate: PropTypes.bool,
  /**
   * Turn off or on the journeyType section
   */
  showJourneyType: PropTypes.bool,
  /**
   * Turn off or on the showDurationTrip section
   */
  showDurationTrip: PropTypes.bool,
  /**
   * Turn off or on the travelClass section
   */
  showTravelClass: PropTypes.bool,
  /**
   * Turn off or on the Pill section
   */
  showPill: PropTypes.bool,
  /**
   * Turn off or on the DepartureInfo section
   */
  showDepartureInfo: PropTypes.bool,
  /**
   * Turn off or on the OriginDestination section
   */
  showOriginDestination: PropTypes.bool,
  /**
   * Turn off or on the ReturnInfo section
   */
  showReturnInfo: PropTypes.bool,
  /**
   * Turn off or on the LastSeen section
   */
  showLastSeen: PropTypes.bool,
  /**
   * Turn off or on the Price section
   */
  showPrice: PropTypes.bool,
  /**
   * Turn off or on the Miles section
   */
  showMiles: PropTypes.bool,
  /**
   * Determine if fareItemDepartureReturn's section will be before fareItemPrice's section
   */
  showDepartureReturnBeforePrice: PropTypes.bool,
  /**
   * Turn off or on the Horizontal separator
   */
  showHorizontalSeparator: PropTypes.bool,
  /**
   * Turn off or on the Call To Action section
   */
  showCallToAction: PropTypes.bool,
  /**
   * Raw data passed to the object
   */
  data: PropTypes.objectOf(PropTypes.any),
  /**
   * Navigation Info of the pill
   */
  navigationInfo: PropTypes.string,
  /**
   * Flavor of the fareItem
   */
  flavor: PropTypes.oneOf([
    'fareItemCardWithoutBackgroundImage',
    'fareItemCardBackgroundImageMediumFull',
    'fareItemCardBackgroundImageMediumFullMiles',
    'fareItemCardBackgroundImageTallSimple',
    'fareItemCardBackgroundImageTallSimpleCentered',
    'fareItemCardBackgroundImageTallOverlaySimpleCenteredMiles',
    'fareItemCardBackgroundImageSmallOverlaySimpleCentered',
    'fareItemCardCurrencyCard',
    'fareItemCardCurrencyCardMobile',
    'fareItemCardMilesCard',
    'fareItemCardHeroCard',
    'fareItemCardHeroCardMobile',
    'fareItemCardHeroCardLover',
    'fareItemCardCurrencyCardLover',
    'fareItemCardCurrencyCardLight'
  ]),
  /**
   * Possible interactions will be Popup or Direct Deeplink
   */
  interactionHotZone: PropTypes.oneOf(['smart', 'whole', 'button']),
  /**
   * Determine if the component is protected using ErrorBoundary.
   * By default all components protect themselves
   */
  usedErrorBoundary: PropTypes.bool,
  /**
   * Data test ID of FareItem
   */
  dataTestId: PropTypes.string,
  /**
   * Turn off or on BackgroundImage
   */
  showBackgroundImage: PropTypes.bool,
  experimentalRenderAtoms: PropTypes.bool,
  experimentalRenderAtomsFooter: PropTypes.bool,
  availableAtoms: PropTypes.arrayOf(
    PropTypes.oneOf([
      'FareItemOriginDestination',
      'FareItemTripDuration',
      'FareItemSeparator',
      'FareItemMiles',
      'FareItemPrice',
      'FareItemLastSeen',
      'FareItemDepartureReturnInfo',
      'FareItemJourneyTypeTravelClass',
      'FareItemCallToAction',
      'FareItemCheckRestriction',
      'FareItemAirline',
      'FareItemRating',
      'FareItemTags',
      'FareItemHotelName'
    ])
  ),

  availableAtomsFooter: PropTypes.arrayOf(PropTypes.oneOf(['FareItemCallToAction'])),
  ariaLabel: PropTypes.string
};

FareItemCard.componentName = 'FareItemCard';

FareItemCard.flavors = flavors;

export default withFlavors(FareItemCard, defaultProps);
